import React, { useState } from 'react'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from '../SchoolShow_style'
import IconFactory from 'icons/IconFactory/IconFactory'

const SchoolFaqItem = (props) => {
    const { faq } = props
    const [open, setOpen] = useState(false)
    const classes = useStyles()

    return (
        <Box key={`faq-${faq.id}`} className={classes.faqBox}>
            <Box onClick={() => setOpen(!open)} className={classes.faqQuestion}>
                <Typography variant='h2' component='h3'>
                    {faq.question}
                </Typography>
                {!open && <IconFactory icon='circle-arrow-down' className={classes.faqArrow}/>}
                {open && <IconFactory icon='circle-arrow-up' className={classes.faqArrow}/>}
            </Box>
            <Box className={classes.faqAnswer}>
                {open && <Typography dangerouslySetInnerHTML={{ __html: faq.answer }}/>}
            </Box>
        </Box>
    )
}

export default SchoolFaqItem
